export default {
    state: () => ({
      reloadTree : false,
    }),
    getters: {
      getReloadTree: state => state.reloadTree
    },
    actions: { 
      reloadCourseTree({commit}, bool) {
        commit('setReloadTree', bool);
      }
    },
    mutations: { 
      setReloadTree(state, bool) {
        state.reloadTree = bool;
      },
      
    },
  }